import { RootState } from '../../../store';

export const getAchievementsSelector = (state: RootState) => state.achievements.achievements;
export const getAchievementsLoadingSelector = (state: RootState) => state.achievements.isLoading;
export const getAchievementsPageSelector = (state: RootState) => state.achievements.page;
export const getAchievementsLoadMore = (state: RootState) => state.achievements.loadMore;
